import { render, staticRenderFns } from "./PayPalPayDialog.vue?vue&type=template&id=42cd0c58&scoped=true&"
import script from "./PayPalPayDialog.vue?vue&type=script&lang=js&"
export * from "./PayPalPayDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cd0c58",
  null
  
)

export default component.exports